import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Mariela G.', 'Laura P.', 'Roberto M.', 'Cecilia R.', 'Florencia L.', 'Valeria T.', 'Juan C.', 'Martín S.', 'Lucía F.', 'Diego A.'];
const cities = ['Córdoba', 'Rosario', 'Buenos Aires', 'Mendoza', 'Tucumán', 'Santa Fe', 'Salta', 'Neuquén', 'Mar del Plata', 'La Plata'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 30000);
    // Then show every 30 seconds
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-216">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-stone-200 p-4 max-w-sm flex items-start gap-3" data-id="element-217">
          <div className="bg-emerald-100 p-2 rounded-full flex-shrink-0" data-id="element-218">
            <CheckCircle2 className="w-5 h-5 text-emerald-600" data-id="element-219" />
          </div>
          <div data-id="element-220">
            <p className="text-sm text-stone-600" data-id="element-221">Alguien acaba de comprar</p>
            <p className="font-bold text-stone-900 text-sm" data-id="element-222">
              Lengua Pack Completo
            </p>
            <p className="text-xs text-stone-500 mt-1" data-id="element-223">
              {buyer.name} desde {buyer.city}, Argentina
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}